'use strict';

import {observable, configure, action, makeObservable, flow} from "mobx";
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import {isTrue, isFalse, isEmpty} from '@uw-it-sis/lib-react/lib/Utils';
import {buildRegistrationSlnList} from '@uw-it-sis/lib-react-myplan/lib/RegistrationUtils';
import {MetricLabels} from "@uw-it-sis/lib-react-myplan/lib/Constants";

import api from '../lib/Api';
import registrationDetailsStore from "./RegistrationDetailsStore";

const analyticsStore = appStore.getAnalyticsStore();
// Start an analytics timer event.
const timerEventName = "Registration-Submission-Tracking-Result";

class RegisterStore {
    state = States.initial;

    exceptionUtils = appStore.getExceptionUtils();

    registrationChanges = [];

    result = {};

    termId = "";

    showModal = false;

    constructor() {
        makeObservable(this, {
            state: observable,
            mount: action,
            showModal: observable,
            openModal: action,
            closeModal: action
        })
    }

    mount = (termId) => {
        this.state = States.initial;
        this.registrationChanges = [];
        this.termId = termId;
        let readyList = registrationDetailsStore.getRegistrationItems();

        let selectedCourses = [];
        readyList.map((course, i) => {
            if (isTrue(course['sendToRegistration'])) {
                selectedCourses.push(course);
            }
        });
        let slns = buildRegistrationSlnList(selectedCourses);

        let slnsToEntryCodes = {};

        readyList.map((course, i) => {
            course.planActivities.map(function (activity, j) {
                let sln = activity['registrationCode'];
                slnsToEntryCodes[sln] = activity['entryCode'];
            });
        });

        slns.map(sln => {
            this.registrationChanges.push({
                action: "A",
                section: {
                    sln: sln
                },
                accessCode: slnsToEntryCodes[sln]
            })
        })

        this.state = States.done;
    }

    openModal = () => this.showModal = true;
    closeModal = () => this.showModal = false;

    submitRegistration = flow(function* () {
        const labels = analyticsStore.label(MetricLabels.quarter, this.termId).get();
        analyticsStore.startTimer(timerEventName, labels);
        this.state = States.pending;
        this.openModal();

        try {
            this.result = yield api.postRegistration(this.termId, this.registrationChanges);
            this._doSubmitRegistrationAnalytics(this.result)
            this.state = States.done;
        } catch (e) {
            this.exceptionUtils.handleException(e);
            this.state = States.error;
        }

    }.bind(this));

    hasChanges = () => {
        // check to see if the registration changes list is empty or not; when changes are made to items in the ready state and checkboxes for activites
        return this.registrationChanges.length > 0;
    }

    _doSubmitRegistrationAnalytics = (result) => {
        let changes = [];

        result.registrationChanges.map(change => {
            let temp = registrationDetailsStore.getRegistrationItemBySln(change.section.sln);
            if (temp) {
                temp.messages = change.messages?.map(msg => msg.messageNumber).join(",") ?? "";
                changes.push(temp);
            }
        })

        let additionalData = {
            result: result.nextAction,
            changes: changes
        };

        analyticsStore.endTimer(timerEventName, additionalData);
    }
}

export default new RegisterStore();